
export default function EnquiryApi({ makeRequest, buildRequest }) {
	function getEnquiries(params) {
		return buildRequest().then((req) =>
			makeRequest(req.get('/api/Enquiry', { params }))
		);
	}

	function getHistoricEnquiries(params) {
		return buildRequest().then((req) =>
			makeRequest(req.get('/api/Enquiry/advanced', { params, paramsSerializer: { indexes: null } }))
		);
	}

	function getOnHoldEnquiries(params) {
		return buildRequest().then((req) =>
			makeRequest(req.get('/api/Enquiry/onhold', { params }))
		);
	}

	function getMergeableEnquiries(params) {
		return buildRequest().then((req) =>
			makeRequest(req.get('/api/Enquiry/mergeable', { params }))
		);
	}

	function getEnquiryDuplicates(enquiryId) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/Enquiry/${enquiryId}/duplicates`))
		);
	}

	function getEnquiry(enquiryId) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/Enquiry/${enquiryId}`))
		);
	}

	function getEnquirySummary(enquiryId) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/Enquiry/${enquiryId}/summary`))
		);
	}

	function getEnquiryChildren(enquiryId) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/Enquiry/${enquiryId}/children`))
		);
	}

	function getEnquiryContacts(enquiryId) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/Enquiry/${enquiryId}/contacts`))
		);
	}

	function getEnquiryCentres(enquiryId) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/Enquiry/${enquiryId}/centres`))
		);
	}

	function getEnquiryTours(enquiryId) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/Enquiry/${enquiryId}/centres-tours`))
		);
	}

	function getEnquiryTourBookings(enquiryId) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/Enquiry/${enquiryId}/tour-bookings`))
		);
	}

	function createEnquiry(payload) {
		return buildRequest().then((req) =>
			makeRequest(req.post('/api/Enquiry', payload))
		);
	}

	function updateEnquiry(enquiryId, payload) {
		return buildRequest().then((req) =>
			makeRequest(req.put(`/api/Enquiry/${enquiryId}`, payload))
		);
	}

	function addEnquiryTag(enquiryId, payload) {
		return buildRequest().then((req) =>
			makeRequest(req.post(`/api/Enquiry/${enquiryId}/tags`, payload))
		);
	}

	function removeEnquiryTag(enquiryId, tagId) {
		return buildRequest().then((req) =>
			makeRequest(req.delete(`/api/Enquiry/${enquiryId}/tags/${tagId}`))
		);
	}

	function deleteEnquiry(enquiryId) {
		return buildRequest().then((req) =>
			makeRequest(req.delete(`/api/Enquiry/${enquiryId}`))
		);
	}

	function resolveDuplicates(enquiryId) {
		return buildRequest().then((req) =>
			makeRequest(req.delete(`/api/Enquiry/${enquiryId}/duplicates`))
		);
	}

	function putEnquiryOnHold(enquiryId, payload) {
		return buildRequest().then((req) =>
			makeRequest(req.post(`/api/Enquiry/${enquiryId}/onhold`, payload))
		);
	}

	function removeEnquiryOnHold(enquiryId) {
		return buildRequest().then((req) =>
			makeRequest(req.delete(`/api/Enquiry/${enquiryId}/onhold`))
		);
	}

	function cancelEnquiry(enquiryId, payload) {
		return buildRequest().then((req) =>
			makeRequest(req.post(`/api/Enquiry/${enquiryId}/cancel`, payload))
		);
	}

	function upsertNote(payload) {
		return buildRequest().then((req) =>
			makeRequest(req.post('/api/Enquiry/notes', payload))
		);
	}

	function getEnquiryNotes(enquiryId) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/Enquiry/${enquiryId}/notes`))
		);
	}

	function getEnquiryStatusAudit(enquiryId) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/Enquiry/${enquiryId}/status-audit`))
		);
	}

	function upsertEnquiryContact(payload) {
		return buildRequest().then((req) =>
			makeRequest(req.post(`/api/Enquiry/${payload.enquiryId}/contacts`, payload))
		);
	}

	function deleteEnquiryContact(enquiryContactId) {
		return buildRequest().then((req) =>
			makeRequest(req.delete(`/api/Enquiry/contacts/${enquiryContactId}`))
		);
	}

	function upsertEnquiryChild(payload) {
		return buildRequest().then((req) =>
			makeRequest(req.post(`/api/Enquiry/${payload.enquiryId}/children`, payload))
		);
	}

	function deleteEnquiryChild(enquiryChildId) {
		return buildRequest().then((req) =>
			makeRequest(req.delete(`/api/Enquiry/children/${enquiryChildId}`))
		);
	}

	function copyEnquiryChildProposedBookings(enquiryId, enquiryChildId, payload) {
		return buildRequest().then((req) =>
			makeRequest(req.post(`/api/Enquiry/${enquiryId}/children/${enquiryChildId}/proposed-bookings/copy`, payload))
		);
	}

	function withdrawChildFromCentre(enquiryChildId, enquiryCentreId) {
		return buildRequest().then((req) =>
			makeRequest(req.post(`/api/Enquiry/children/${enquiryChildId}/centres/${enquiryCentreId}/withdraw`))
		);
	}

	function clearChildCentreWithdrawal(enquiryChildId, enquiryCentreId) {
		return buildRequest().then((req) =>
			makeRequest(req.delete(`/api/Enquiry/children/${enquiryChildId}/centres/${enquiryCentreId}/withdraw`))
		);
	}

	function upsertEnquiryCentre(payload) {
		return buildRequest().then((req) =>
			makeRequest(req.post(`/api/Enquiry/${payload.enquiryId}/centres`, payload))
		);
	}

	function deleteEnquiryCentre(enquiryCentreId) {
		return buildRequest().then((req) =>
			makeRequest(req.delete(`/api/Enquiry/centres/${enquiryCentreId}`))
		);
	}

	function mergeEnquiry(payload) {
		return buildRequest().then((req) =>
			makeRequest(req.post('/api/Enquiry/merge', payload))
		);
	}

	function generateEnrolment(payload) {
		return buildRequest().then((req) =>
			makeRequest(req.post('/api/Enrolment', payload))
		);
	}

	function checkDuplicateContact(params) {
		return buildRequest().then((req) =>
			makeRequest(req.get('/api/Enquiry/check-duplicate-contact', { params }))
		);
	}

	return {
		getEnquiries,
		getHistoricEnquiries,
		getOnHoldEnquiries,
		getMergeableEnquiries,
		getEnquiryDuplicates,
		getEnquiry,
		getEnquirySummary,
		getEnquiryChildren,
		getEnquiryContacts,
		getEnquiryCentres,
		getEnquiryTours,
		getEnquiryTourBookings,
		createEnquiry,
		updateEnquiry,
		addEnquiryTag,
		removeEnquiryTag,
		deleteEnquiry,
		resolveDuplicates,
		putEnquiryOnHold,
		removeEnquiryOnHold,
		cancelEnquiry,
		upsertNote,
		getEnquiryNotes,
		getEnquiryStatusAudit,
		upsertEnquiryContact,
		deleteEnquiryContact,
		upsertEnquiryChild,
		deleteEnquiryChild,
		copyEnquiryChildProposedBookings,
		withdrawChildFromCentre,
		clearChildCentreWithdrawal,
		upsertEnquiryCentre,
		deleteEnquiryCentre,
		mergeEnquiry,
		generateEnrolment ,
		checkDuplicateContact,
	};
}
